import React from "react";
import classnames from "classnames";
import { useProjectType } from "../../Hooks/EntityHooks";

const ProjectTypeProfile = ({ Projecttype, className }) => {
  //   console.log(Projecttype);
  if (!Projecttype) return null;
  return (
    <div className={classnames("d-flex align-items-center", className)}>
      <div className="flex-1">
        <div>
          {Projecttype.Type} - {Projecttype.Name}
        </div>
      </div>
    </div>
  );
};

export default ProjectTypeProfile;

export const ConnectProjectTypeEntity = Component => {
  return ({ Projecttype, ...rest }) => {
    //console.log(Projecttype);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const a = useProjectType(Projecttype);
    return <Component Projecttype={a} {...rest} />;
  };
};

export const ConnectedProjectTypeProfile = ConnectProjectTypeEntity(
  ProjectTypeProfile
);

// const mapStateToProps = (state, ownProps) => {
//   return {
//     Projecttype: state.Entities.SpaceProjectTypes[ownProps.Projecttype]
//   };
// };

// export const ConnectedProjectTypeProfile = connect(mapStateToProps)(
//   ProjectTypeProfile
// );
